<template>
    <nav class="navbar">
        <router-link to="/">
            <i class="fas fa-home" aria-hidden="true"><span>Home</span></i>
        </router-link>
        <router-link to="/about">
            <i class="fas fa-user" aria-hidden="true"><span>About</span></i>
        </router-link>
        <router-link to="/portfolio">
            <i class="fas fa-briefcase" aria-hidden="true"><span>Portfolio</span></i>
        </router-link>
        <router-link to="/contacts">
            <i class="fas fa-address-book" aria-hidden="true"><span>Contact</span></i>
        </router-link>
    </nav>
</template>

<script>
    export default {
      name: "Footerview"
    }
</script>

<style scoped>
.navbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 1000;
  align-items: flex-end;
}
.navbar a {
  padding: 2rem;
  font-size: 2rem;
  background: #1a1a1a;
  flex: 1;
  color: #fff;
  text-align: center;
  transition: .2s linear;
}
.navbar a i {
  color: crimson;
  padding-right: .5rem;
}
.navbar a:hover {
  background-color: crimson;
  padding-bottom: 6rem;
}
.navbar a:hover i {
  color: #fff;
}

.navbar a i span {
  margin-left: 10px;
}

@media (max-width: 768px) {
  .navbar a i {
    padding: 0;
  }
  .navbar a span {
    display: none;
  }
  .navbar a:hover {
    padding-bottom: 2rem;
  }
}
</style>